// extracted by mini-css-extract-plugin
export default {"projectOverview":"EventzoneProjectOverview_projectOverview__K5mtP"};